import clsx from 'clsx'
import { IO_LINE_TRACING_ENABLED } from '@/config/ioLineTracing'
import { useTranslation } from '@/i18n'

export type DocumentTab = 'review' | 'extractions' | 'raw' | 'summary' | 'details' | 'lines'

interface DocumentTabsProps {
  activeTab: DocumentTab
  onTabChange: (tab: DocumentTab) => void
}

const TABS: { id: DocumentTab; labelKey: string; labelDefault: string }[] = [
  { id: 'review', labelKey: 'tabs.review', labelDefault: 'Review' },
  { id: 'extractions', labelKey: 'tabs.extractions', labelDefault: 'Extractions' },
  ...(IO_LINE_TRACING_ENABLED ? [{ id: 'lines' as const, labelKey: 'tabs.lines', labelDefault: 'Lines' }] : []),
  { id: 'raw', labelKey: 'tabs.raw', labelDefault: 'Raw' },
  { id: 'summary', labelKey: 'tabs.summary', labelDefault: 'Summary' },
  { id: 'details', labelKey: 'tabs.details', labelDefault: 'Details' },
]

export function DocumentTabs({ activeTab, onTabChange }: DocumentTabsProps) {
  const { t } = useTranslation()
  return (
    <div className="flex gap-4 border-b bg-white dark:bg-dark-card px-4 overflow-x-auto shrink-0" style={{ position: 'relative', zIndex: 1 }}>
      {TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={clsx(
            'pb-3 pt-4 font-medium text-sm border-b-2 transition-colors cursor-pointer whitespace-nowrap',
            activeTab === tab.id
              ? 'text-blue-600 border-blue-600 dark:text-blue-400 dark:border-blue-400'
              : 'text-gray-600 dark:text-gray-400 border-transparent hover:text-gray-900 dark:hover:text-dark-text hover:border-gray-300 dark:hover:border-gray-600'
          )}
        >
          {t(`document_viewer:${tab.labelKey}`, { defaultValue: tab.labelDefault })}
        </button>
      ))}
    </div>
  )
}

